import axios from 'axios';

import consts from '../consts';
import { setErroAPI, setSuccess, setError } from '../common/toast/toast';

const chaveLote = (idProducao, indiceBatida) => (
	`${idProducao}:${indiceBatida}`
);

function mesclarAlteracoesLocais(cargaServidor, cargaLocal, lotesSalvos) {
	if (!cargaLocal || String(cargaServidor.id) !== String(cargaLocal.id)) {
		return cargaServidor;
	}

	const chavesSalvas = new Set((lotesSalvos || []).map(item => (
		chaveLote(item.id_producao, item.indice_batida)
	)));

	return {
		...cargaServidor,
		producoes: (cargaServidor.producoes || []).map(producao => {
			const producaoLocal = (cargaLocal.producoes || []).find(item => (
				String(item.id_producao) === String(producao.id_producao)
			));

			if (!producaoLocal) return producao;

			return {
				...producao,
				itens: (producao.itens || []).map((batida, indiceBatida) => {
					const batidaLocal = (producaoLocal.itens || [])[indiceBatida];
					const chave = chaveLote(producao.id_producao, indiceBatida);

					return batidaLocal
						&& batidaLocal.lote_alterado
						&& !chavesSalvas.has(chave)
							? {
								...batida,
								lote_producao: batidaLocal.lote_producao,
								lote_alterado: true
							}
							: batida;
				})
			};
		})
	};
}

export function setAguardando(aguardando) {
	return {
		type: 'PRODUCAO_CARGA_SET_AGUARDANDO',
		payload: aguardando
	};
}

export function setSalvando(salvando) {
	return {
		type: 'PRODUCAO_CARGA_SET_SALVANDO',
		payload: salvando
	};
}

export function setCarga(carga) {
	return {
		type: 'PRODUCAO_CARGA_CARREGADA',
		payload: carga
	};
}

export function limparCarga() {
	return {
		type: 'PRODUCAO_CARGA_LIMPAR'
	};
}

export function buscarCarga(codigo) {
	return dispatch => {
		const codigoNormalizado = String(codigo || '').trim();

		if (!codigoNormalizado) {
			setError('Leia ou informe o código de barras da carga.');
			return Promise.resolve(false);
		}

		dispatch(setAguardando(true));

		return axios.get(
			`${consts.API_URL}/producaoCarga?codigo=${encodeURIComponent(codigoNormalizado)}`
		).then(resp => {
			dispatch(setCarga(resp.data));
			return true;
		}).catch(e => {
			setErroAPI(e);
			return false;
		}).finally(() => dispatch(setAguardando(false)));
	};
}

export function getHistorico(idCarga) {
	return dispatch => {
		dispatch(setAguardando(true));

		return axios.get(`${consts.API_URL}/producaoCarga/historico?id_carga=${idCarga}`)
			.then(resp => {
				dispatch({
					type: 'PRODUCAO_CARGA_HISTORICO_LISTADO',
					payload: resp.data || []
				});
				return true;
			})
			.catch(e => {
				setErroAPI(e);
				return false;
			})
			.finally(() => dispatch(setAguardando(false)));
	};
}

function executarAcao(url, registro, mensagem) {
	return dispatch => {
		dispatch(setAguardando(true));

		return axios.post(`${consts.API_URL}${url}`, registro)
			.then(resp => {
				dispatch(setCarga(resp.data));
				setSuccess(mensagem);
				return true;
			})
			.catch(e => {
				setErroAPI(e);
				return false;
			})
			.finally(() => dispatch(setAguardando(false)));
	};
}

export function iniciarProducaoCarga(idCarga) {
	return executarAcao(
		'/producaoCarga/iniciar',
		{ id_carga: idCarga },
		'Produção da carga iniciada com sucesso.'
	);
}

export function cancelarInicioProducaoCarga(idCarga, motivo) {
	if (!(motivo || '').trim()) {
		setError('Informe o motivo do cancelamento do início.');
		return () => Promise.resolve(false);
	}

	return executarAcao(
		'/producaoCarga/cancelarInicio',
		{ id_carga: idCarga, motivo: motivo.trim() },
		'Início da produção cancelado com sucesso.'
	);
}

export function finalizarProducaoCarga(idCarga) {
	return executarAcao(
		'/producaoCarga/finalizar',
		{ id_carga: idCarga },
		'Produção da carga finalizada com sucesso.'
	);
}

export function reabrirProducaoCarga(idCarga, motivo) {
	if (!(motivo || '').trim()) {
		setError('Informe o motivo da reabertura.');
		return () => Promise.resolve(false);
	}

	return executarAcao(
		'/producaoCarga/reabrir',
		{ id_carga: idCarga, motivo: motivo.trim() },
		'Produção da carga reaberta com sucesso.'
	);
}

export function salvarLotes(idCarga, lotes, silencioso = false) {
	return (dispatch, getState) => {
		dispatch(setSalvando(true));

		return axios.put(`${consts.API_URL}/producaoCarga/lotes`, {
			id_carga: idCarga,
			lotes: lotes || []
		}).then(resp => {
			const cargaAtual = getState().producaoCarga.carga;

			if (!cargaAtual || String(cargaAtual.id) !== String(resp.data.id)) {
				return true;
			}

			const carga = mesclarAlteracoesLocais(
				resp.data,
				cargaAtual,
				lotes
			);

			dispatch(setCarga(carga));

			if (!silencioso) {
				setSuccess('Lotes salvos com sucesso.');
			}

			return true;
		}).catch(e => {
			setErroAPI(e);
			return false;
		}).finally(() => dispatch(setSalvando(false)));
	};
}
